import Config from '../Containers/Config'

export default class Image {
    element = document.createElement('img')
    id: string

    constructor(src: string) {
        this.id = src
        this.element.addEventListener('error', this.handleError, { once: true })
        this.element.src = src
    }

    handleError = () => {
        if (this.element.src === '') {
            console.error(`Inamove::Image => missing image! Using fallback image.`)
        } else {
            console.error(`Inamove::Image => could not load image at "${this.element.src}"! Using fallback image.`)
        }

        this.element.src = Config.MISSING_IMAGE_PATH
    }

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    load = async () => {
        try {
            await this.element.decode()
        } catch (e) {
            console.error(`Inamove::Image.load => error while loading Image: "${this.element.src}"!`)
            console.error(e)
        }
    }

    destroy = () => {
        this.element.remove()
    }
}
